<template>
  <div class="ic-item-form">
    <el-form ref="form" :model="form" :rules="rules" label-width="100px" inline>
      <div class="flex-item">
        <el-form-item label="产品编号" prop="fNumber">
          <el-input v-model="form.fNumber" :readonly="isReadonly" />
        </el-form-item>
        <el-form-item label="产品名称" prop="fName">
          <el-input v-model="form.fName" />
        </el-form-item>
        <el-form-item label="仓库" prop="fStockID">
          <el-select-ex
            v-model="form.fStockID"
            url="Warehouse/Stock/StockEntry"
            label-field="fName"
            value-field="fStockID"
          />
        </el-form-item>
        <el-form-item label="规格">
          <el-input v-model="form.fModel" />
        </el-form-item>
        <!-- <el-form-item label="零散库存数">
        <el-input type="number" v-model.number="form.fLsQty" min="0"/>
      </el-form-item> -->
      </div>

      <div class="flex-item">
        <el-form-item label="供应商">
          <el-input v-model="form.fSupplier" />
        </el-form-item>
        <el-form-item label="生产企业">
          <el-input v-model="form.fProduction" />
        </el-form-item>
        <el-form-item label="单位" prop="fUnit">
          <el-input v-model="form.fUnit" />
        </el-form-item>
        <el-form-item label="有效期(月)" prop="fValidity">
          <el-input v-model.number="form.fValidity" type="number" />
        </el-form-item>
      </div>

      <div class="flex-item">
        <el-form-item label="结算价" prop="fPrice">
          <el-input-currency v-model="form.fPrice" :scale="2" />
        </el-form-item>
        <el-form-item label="注册号">
          <el-input v-model="form.fRegisterNumber" />
        </el-form-item>
        <el-form-item label="生产许可证号">
          <el-input v-model="form.fProductionNumber" />
        </el-form-item>
        <el-form-item label="经营许可证号">
          <el-input v-model="form.fManageNumber" />
        </el-form-item>
      </div>

      <div class="flex-item">
        <el-form-item label="次品">
          <el-select-table
            v-model="form.fICItemID_cp"
            :label.sync="form.fNumber_cp"
            url="ICItemManage/ICItem/ChoiceICItemEntry"
            label-field="fNumber"
            value-field="ficItemID"
            panel-width="500px"
            :clearable="false"
            :columns="[
              { prop: 'fNumber', label: '编码' },
              { prop: 'fName', label: '名称' },
              { prop: 'fModel', label: '规格' },
              { prop: 'fUnit', label: '单位' },
            ]"
            @change="fNumber_cpChange"
          />
        </el-form-item>
        <el-form-item label="注册/备案人">
          <el-input v-model="form.fRegistrar" />
        </el-form-item>
        <el-form-item label="生产按月显示">
          <el-radio-group v-model="form.fIsMonthDisplay">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="停产">
          <el-radio-group v-model="form.fProhibit">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
      </div>
    </el-form>
    <el-form ref="form" :model="form" :rules="rules" label-width="100px">
      <div class="flext-item">
        <el-row>
          <el-col :span="18">
            <el-form-item label="运输条件">
              <el-input
                v-model="form.fTransportDes"
                type="textarea"
                :rows="3"
              />
            </el-form-item>
            <el-form-item label="简介">
              <el-input v-model="form.fDes" type="textarea" :rows="3" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="照片">
              <template v-if="imgSrc">
                <img width="150" height="150" :src="imgSrc">
                <el-button
                  size="small"
                  type="text"
                  style="margin-left: 10px"
                  @click="_import"
                >更换</el-button>
              </template>
              <template v-else>
                <el-button
                  size="small"
                  icon="el-icon-plus"
                  circle
                  @click="_import"
                />
              </template>
              <input
                ref="fileSel"
                type="file"
                style="display: none"
                accept="image/jpeg, image/jpg, image/png"
              >
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>
  </div>
</template>

<script>
import ElInputCurrency from '../../../components/ElInputCurrency.vue'

export default {
  components: { ElInputCurrency },
  props: {
    form: Object
  },
  data: function() {
    return {
      rules: {
        fNumber: [{ required: true, message: '必填项', trigger: 'change' }],
        fName: [{ required: true, message: '必填项', trigger: 'change' }],
        fStockID: [{ required: true, message: '必填项', trigger: 'change' }],
        fUnit: [{ required: true, message: '必填项', trigger: 'change' }],
        fPrice: [{ required: true, message: '必填项', trigger: 'change' }],
        fValidity: [{ required: true, message: '必填项', trigger: 'change' }]
      },
      imgSrc: null,
      imgFile: null
    }
  },
  computed: {
    isReadonly: function() {
      // console.log(this.form, "this.form");
      if (this.form.ficItemID) {
        return true
      }
    }
  },
  mounted: function() {
    setTimeout(() => {
      // console.log(this.form.pictureUrl, this.form.fPassword)
      this.imgSrc = this.form.pictureUrl
    }, 10)
  },
  methods: {
    fNumber_cpChange: function(item) {
      this.form.fNumber_cp = item ? item.fNumber : null
    },
    submit: function(onValid, onSuccess, onFailed, onComplete) {
      this.$refs.form.validate((valid) => {
        if (valid) {
          onValid({
            data: this.form,
            file: this.imgFile
          })
        } else {
          return false
        }
      })
    },
    _import: function() {
      const _this = this
      var fileSel = this.$refs.fileSel
      fileSel.onchange = () => {
        setTimeout(() => {
          fileSel.value = null
        }, 100)
        if (!fileSel.files.length) return
        var file = fileSel.files[0]
        _this.imgFile = file

        var reader = new FileReader()
        reader.onload = function(e) {
          _this.imgSrc = e.target.result
        }
        reader.readAsDataURL(file)
      }
      fileSel.click()
    }
  }
}
</script>

<style lang="less" scoped>
.ic-item-form {
  .flex-item {
    display: flex;
    & > .el-form-item {
      flex: 1;
      & .el-input,
      &.el-select {
      }
    }
  }
  .flext-item {
  }
}
</style>
